/** Shared global-search timing and stale-response boundary, scoped to one control. */
export class SearchScheduler {
  private timer?: ReturnType<typeof setTimeout>;
  private revision = 0;

  schedule(search: () => void): void {
    this.cancelTimer();
    this.timer = setTimeout(() => {
      this.timer = undefined;
      search();
    }, 200);
  }

  invalidate(): number {
    this.cancelTimer();
    return ++this.revision;
  }

  isCurrent(revision: number): boolean {
    return revision === this.revision;
  }

  cancelTimer(): void {
    clearTimeout(this.timer);
    this.timer = undefined;
  }
}
